import { Popover } from "@/components/Popover/Popover";
import KeyIcon from "@medoma/components/icons/KeyIcon";
import { useLingui } from "@lingui/react/macro";
import { TextWithLineBreaks } from "@medoma/components/Text/Text";
import styles from "./KeyToPatientPopover.module.scss";

export const KeyToPatientPopover = ({ details }: { details: string }) => {
  const { t } = useLingui();

  return (
    <Popover
      trigger={{
        custom: (
          <div className={styles.keyIcon}>
            <KeyIcon />
          </div>
        ),
        ariaLabel: t`Visa information om nyckel till patient`,
      }}
    >
      <TextWithLineBreaks>{details}</TextWithLineBreaks>
    </Popover>
  );
};
